import React from "react";

export const TRANSIA_BANNER = "/brand/reports/transia-grain-banner.png";

// Image shown at the top of the "Du nouveau dans TransIA" announcement.
export default function ProductUpdateCoverPicker({ value, onChange, image, items, disabled = false }) {
  const options = [
    { key: "banner", label: "Bannière TransIA", src: TRANSIA_BANNER },
    ...(image ? [{ key: "image", src: image.data_url, label: "Image du Journal" }] : []),
    ...items.filter(item => item.image).map(item => ({ key: item.item_id, label: item.title, src: item.image.data_url })),
  ];
  return <fieldset className="pu-cover-picker" disabled={disabled}>
    <legend>Bandeau de l'annonce</legend>
    <p className="pu-stage-description">Choisissez l’image affichée en haut de la fenêtre « Du nouveau dans TransIA ». L’image du Journal se prépare à l’étape « 1. Textes et image ». Choisie comme bandeau, elle n’est pas répétée à côté d’une nouveauté.</p>
    <div className="pu-cover-options">{options.map(option =>
      <label key={option.key} className={`pu-cover-option${value === option.key ? " is-selected" : ""}`}>
        <input type="radio" name="pu-cover" checked={value === option.key} onChange={() => onChange(option.key)} />
        <img src={option.src} alt="" /><span>{option.label}</span>
      </label>)}</div>
  </fieldset>;
}
